
import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Toast, ToastType } from './Toast'
import { toastManager } from '@/lib/toastManager'

interface ToastState {
  message: string
  type: ToastType
  id: string
}

export function GlobalToastManager() {
  const [toasts, setToasts] = useState<ToastState[]>([])
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    
    const unsubscribe = toastManager.subscribe(setToasts)
    return unsubscribe
  }, [])

  if (!mounted || typeof window === 'undefined') {
    return null
  }

  return createPortal(
    <div className="fixed top-4 right-4 z-[9999] flex flex-col space-y-2 pointer-events-none">
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            message={toast.message}
            type={toast.type}
            isVisible={true}
            onClose={() => toastManager.hide(toast.id)}
            duration={0} // Gerenciado pelo toastManager
          />
        </div>
      ))}
    </div>,
    document.body
  )
}